import React, { useState } from "react";
import { Tabs, Tab, Box, IconButton, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import QuestionForm from "./QuestionForm";

type Props = {
  questions: any[];
  onChange: (newQuestions: any[]) => void;
};

function QuestionsTabs({ questions, onChange }: Props) {
  const [tabIndex, setTabIndex] = useState(0);

  const addQuestion = () => {
    const newQ = {
      title: `Question ${questions.length + 1}`,
      qNo: "",
      type: "MCQ",
      marks: 1,
      sortOrder: questions.length + 1,
      subject: "",
      chapter: "",
      topic: "",
    };
    const newList = [...questions, newQ];
    onChange(newList);
    setTabIndex(newList.length - 1);
  };

  const removeQuestion = (index: number) => {
    const newList = questions.filter((_, i) => i !== index);
    onChange(newList);
    if (tabIndex >= newList.length) {
      setTabIndex(Math.max(0, newList.length - 1));
    }
  };

  const updateQuestion = (index: number, newData: any) => {
    const newList = [...questions];
    newList[index] = newData;
    onChange(newList);
  };

  return (
    <Box sx={{ backgroundColor: '#f8f9fa', borderRadius: 2, p: 2 }}>
      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2, color: 'text.primary' }}>
        Questions ({questions.length})
      </Typography>
      <Box display="flex" alignItems="center" sx={{ mb: 3 }}>
        <Tabs
          value={tabIndex}
          onChange={(_, v) => setTabIndex(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            "& .MuiTabs-flexContainer": {
              alignItems: "center",
              gap: 1,
            },
            "& .MuiTab-root": {
              minHeight: 40,
              textTransform: "none",
              border: "1px solid #ddd",
              borderRadius: "12px 12px 0 0",
              px: 2.5,
              py: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              maxWidth: "180px",
              fontSize: "0.9rem",
              fontWeight: 500,
              color: "text.secondary",
              transition: "all 0.2s ease-in-out",
              "&:hover": {
                backgroundColor: "#f5f5f5",
                cursor: "pointer",
              },
            },
            "& .Mui-selected": {
              backgroundColor: "#fff",
              borderBottom: "1px solid white",
              fontWeight: 600,
              color: "text.primary",
              boxShadow: "0 -2px 6px rgba(0,0,0,0.08)",
            },
            "& .MuiTabs-scrollButtons": {
              color: "text.secondary",
              "&.Mui-disabled": { opacity: 0.3 },
            },
          }}
        >
          {questions.map((q, i) => (
            <Tab
              key={i}
              label={
                <Box display="flex" alignItems="center">
                  {q.title || `Question ${i + 1}`}
                </Box>
              }
            />
          ))}
        </Tabs>

        {/* Add Question (+) right after tabs, not scrollable */}
        {/* <Tab
          icon={<AddIcon />}
          onClick={addQuestion}
          sx={{
            minHeight: 36,
            border: "1px solid #ddd",
            borderRadius: "12px 12px 0 0",
            minWidth: 48,
            ml: 1,
          }}
        />*/}
      </Box>

      {/* Active Question Form */}
      {questions.map((q, i) =>
        i === tabIndex ? (
          <QuestionForm
            key={i}
            index={i}
            data={q}
            onChange={(newData) => updateQuestion(i, newData)}
          />
        ) : null
      )}
    </Box>
  );
}

export default QuestionsTabs;
